module.exports = __webpack_public_path__ + "static/img/tim_02.85d42c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/scene/tim_02.png
// module id = l3AB
// module chunks = 0